var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Strona nie istnieje.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }